import React from 'react';
import { StaggerRow } from './shell';

const TABS = [
  { label: 'Today', d: 'M4 10.5 12 4l8 6.5V19a1 1 0 0 1-1 1h-4v-5H9v5H5a1 1 0 0 1-1-1z' },
  { label: 'Attend', d: 'M7 3v3M17 3v3M4 9h16M5 6h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z' },
  { label: 'Training', d: 'M4 15V9m16 6V9M7 12h10M6 8v8M18 8v8' },
  { label: 'Results', d: 'M5 20V10m7 10V4m7 16v-6' },
  { label: 'Boats', d: 'M4 17c2.5 2 5 2 8 2s5.5 0 8-2M6 14l1-6h10l1 6M9 8V5h6v3' },
];

export default function PhoneMockup() {
  return (
    <div className="relative mx-auto w-[268px]">
      <div className="rounded-[2.4rem] border border-white/10 bg-slate-950 p-2.5 shadow-[0_40px_80px_-24px_rgba(0,0,0,0.8)] ring-1 ring-white/5">
        <div className="relative overflow-hidden rounded-[1.9rem] bg-slate-100">
          {/* notch */}
          <div className="absolute left-1/2 top-0 z-10 h-5 w-24 -translate-x-1/2 rounded-b-2xl bg-slate-950" />

          {/* app header */}
          <div className="bg-gradient-to-br from-blue-700 to-blue-900 px-4 pb-4 pt-7 text-white">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-[10px] font-medium uppercase tracking-wider text-blue-200">
                  Varsity
                </p>
                <p className="text-base font-bold">Tuesday</p>
              </div>
              <div className="h-7 w-7 rounded-full bg-white/20 ring-1 ring-white/30" />
            </div>
            <div className="mt-3 flex gap-1.5">
              {['54\u00b0 air', '61\u00b0 water', '6 mph'].map((c) => (
                <span
                  key={c}
                  className="rounded-full bg-white/15 px-2 py-0.5 text-[9px] font-medium text-white"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>

          <div className="space-y-2 px-3 py-3">
            <StaggerRow index={0} className="rounded-xl bg-white p-3 shadow-sm ring-1 ring-slate-200">
              <div className="flex items-center justify-between">
                <p className="text-xs font-bold text-slate-900">You&rsquo;re in the 1V</p>
                <span className="rounded bg-slate-900 px-1.5 py-0.5 text-[9px] font-bold text-white">
                  7 seat
                </span>
              </div>
              <p className="mt-0.5 text-[10px] text-slate-500">
                Resolute 8+ &ldquo;Bergman&rdquo; &middot; 5:45 AM
              </p>
              <p className="mt-2 text-[11px] font-semibold text-slate-800">
                Steady state &mdash; 3 &times; 20&prime;
              </p>
              <p className="text-[10px] text-slate-500">r20&ndash;22 &middot; target 2:05.4</p>
            </StaggerRow>

            <StaggerRow index={1} className="rounded-xl bg-white p-3 shadow-sm ring-1 ring-slate-200">
              <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">
                Log training
              </p>
              <div className="mt-1.5 flex items-center justify-between">
                <p className="text-xs text-slate-700">Yesterday&rsquo;s row</p>
                <span className="rounded-full bg-orange-50 px-2 py-0.5 text-[9px] font-semibold text-orange-600">
                  From Strava
                </span>
              </div>
              <p className="mt-0.5 text-[10px] text-slate-500">72 min &middot; 18,400 m &middot; Zone 2</p>
            </StaggerRow>

            <StaggerRow index={2} className="rounded-xl bg-white p-3 shadow-sm ring-1 ring-slate-200">
              <div className="flex items-center justify-between">
                <p className="text-xs font-semibold text-slate-900">2k test Friday</p>
                <span className="text-[10px] font-semibold text-blue-600">Submit</span>
              </div>
              <p className="mt-0.5 text-[10px] text-slate-500">Coach template &middot; 4 &times; 500m splits</p>
            </StaggerRow>
          </div>

          {/* tab bar */}
          <div className="flex items-center justify-around border-t border-slate-200 bg-white px-1 pb-4 pt-2">
            {TABS.map((t, i) => (
              <div key={t.label} className="flex flex-col items-center gap-0.5">
                <svg
                  className={`h-4 w-4 ${i === 0 ? 'text-blue-600' : 'text-slate-400'}`}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path d={t.d} />
                </svg>
                <span
                  className={`text-[8px] ${i === 0 ? 'font-semibold text-blue-600' : 'text-slate-400'}`}
                >
                  {t.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
